import type { StringTable } from '../types'

export const ko: StringTable = {
  'common.playbackSpeed': '재생 속도',
  // Navigation
  'nav.review': '복습',
  'nav.library': '라이브러리',
  'nav.stats': '통계',
  'nav.settings': '설정',
  'nav.appTitleSuffix': '어휘 플래시카드',
  'nav.openMenu': '메뉴 열기',
  'nav.closeMenu': '메뉴 닫기',
  'nav.mainNav': '메인 내비게이션',
  'nav.reviewSession': '복습 세션',
  'nav.cardLibrary': '카드 라이브러리',
  'nav.media': '동영상',
  'nav.statistics': '통계',
  'nav.create.label': '만들기',
  'nav.create.text': '텍스트',
  'nav.create.doc': '문서',
  'nav.create.media': '동영상 / 오디오',

  // Generate view
  'generate.takePhoto': '촬영',
  'generate.changePhoto': '사진 변경',
  'generate.chooseGallery': '갤러리',
  'generate.clearText': '텍스트 지우기',
  'generate.button': '카드 생성',
  'generate.buttonPhoto': '사진으로 생성',
  'generate.buttonText': '텍스트로 생성',
  'generate.buttonBoth': '사진+텍스트로 생성',
  'generate.buttonLoading': '생성 중...',
  'generate.minInput': '사진이나 텍스트를 추가하세요',
  'generate.convertingHeic': 'HEIC 변환 중...',
  'generate.compressing': '압축 중...',
  'generate.retry': '다시 시도',
  'generate.removeImage': '이미지 제거',
  'generate.cardTextInput': '카드 텍스트 입력',
  'generate.preview': '미리보기',

  // Generate errors
  'generate.error.invalidImage': '이미지를 업로드해 주세요 (JPEG, PNG, GIF, WebP, HEIC)',
  'generate.error.imageTooLarge': '이미지 크기는 {{maxSize}} 이하여야 합니다',
  'generate.error.compressionFailed': '압축 후에도 이미지가 너무 큽니다. 더 작은 사진을 사용해 보세요',
  'generate.error.heicFailed': '이미지 처리에 실패했습니다',
  'generate.error.generateFailed': '카드 생성에 실패했습니다',

  // Generate — daily cap / upgrade
  'generate.cap.body': '잔액 부족 ({{balance}} 에너지). 충전하고 계속 생성하세요.',
  'generate.cap.upgrade': '충전',

  // Generate — energy badge + first-session banner (balance visibility)
  'generate.energyBadge.label': '에너지 잔액: {{balance}}',
  'generate.energyBadge.zero': '에너지가 없습니다',
  'generate.firstCard.body': '{{balance}} 에너지가 있어요 — 첫 카드를 만들기에 충분해요. 아래에 단어를 입력해 보세요 →',
  'generate.firstCard.dismiss': '닫기',
  'generate.sampleWords.label': '이 단어로 시작해 보세요:',
  'generate.aiImageToggle': 'AI 이미지',
  'generate.aiImageHint': '남길 카드에 AI 이미지 추가 (카드당 {{cost}})',
  'generate.aiImageAutoSkip': '일부 AI 이미지를 추가하지 못했습니다 — 각 카드의 이미지 버튼을 탭해 다시 시도하세요.',

  // Library view
  'library.loading': '라이브러리 로드 중...',
  'library.retry': '다시 시도',
  'library.noCards': '아직 카드가 없습니다!',
  'library.noCardsHint': '플래시카드를 생성하여 라이브러리를 만들어 보세요',
  'library.emptyExtensionHint': '팁: YouTube를 보면서 단어를 선택하고 Piccard 확장 프로그램으로 한 번에 저장하세요.', 'library.emptyCta': '첫 카드 만들기',
  'library.dismiss': '닫기',
  'library.deleteTitle': '카드를 삭제할까요?',
  'library.deleteConfirm': '이 작업은 되돌릴 수 없습니다. 정말 삭제하시겠습니까?',
  'library.cancel': '취소',
  'library.deleting': '삭제 중...',
  'library.delete': '삭제',
  'library.filterAll': '전체',
  'library.filterLearning': '학습 중',
  'library.filterMastered': '마스터 완료',
  'library.card_one': '카드 {{count}}장',
  'library.card_other': '카드 {{count}}장',
  'library.match_one': '{{count}}개 일치',
  'library.match_other': '{{count}}개 일치',
  'library.noCardsMatch': '"{{query}}"과(와) 일치하는 카드가 없습니다',
  'library.prevPage': '이전 페이지',
  'library.nextPage': '다음 페이지',
  'library.searchImagesFor': '{{word}} 이미지 검색',
  'library.unmaster': '{{word}} 마스터 해제',
  'library.markMastered': '{{word}}을(를) 마스터로 표시',
  'library.searchPlaceholder': '{{filter}}카드 검색...',
  'library.drag': '드래그',
  'library.swipeHint': '← 삭제 · 보기 →',
  'library.back': '뒷면',
  'library.images': '이미지',
  'library.master': '마스터',
  'library.mastered': '마스터 완료',
  'library.view': '보기',
  'library.fromMedia': '미디어에서',
  'library.fromDoc': '문서에서',

  // Review view
  'review.ready': '복습할 준비가 되셨나요?',
  'review.readyHint': '주제를 선택하거나 복습 예정인 모든 카드를 시작하세요',
  'review.recognition': '인식',
  'review.production': '생성',
  'review.topics': '주제',
  'review.domains': '분야',
  'review.startReview': '복습 시작',
  'review.loading': '카드 로드 중...',
  'review.retry': '다시 시도',
  'review.tapFlip': '탭하여 뒤집기',
  'review.answer': '정답',
  'review.newWord': '새 단어',
  'review.cardProgress': '{{current}} / {{total}} 카드',
  'review.searchImagesFor': '{{word}} 이미지 검색',
  'review.allCaughtUp': '모두 복습했습니다!',
  'review.nothingToReview': '지금은 복습할 카드가 없습니다',
  'review.makeSomeCards': '카드 만들기',
  'review.makeMoreCards': '"{{topic}}" 카드 더 만들기',
  'review.backToReview': '복습으로 돌아가기',
  'review.noMatchTitle': '"{{topic}}"과(와) 일치하는 카드가 없습니다',
  'review.noMatchHint': '주제와 부분적으로 일치하는 카드를 포함합니다',
  'review.fallbackTitle': '"{{topic}}"과(와) 일치하는 카드가 없습니다 — 복습 예정인 모든 카드를 표시합니다',
  'review.sessionComplete': '복습 완료!',
  'review.cardsReviewed': '복습한 카드',
  'review.again': '다시',
  'review.hard': '어려움',
  'review.good': '좋음',
  'review.easy': '쉬움',
  'review.timeSpent': '소요 시간',
  'review.cardReviewed_one': '오늘 복습한 카드 {{count}}장',
  'review.cardReviewed_other': '오늘 복습한 카드 {{count}}장',
  'review.startNewSession': '새 세션 시작',

  // Share check-in card (issue #1 — /s/:slug poster pages)
  'share.cta': '오늘의 인증 카드 공유',
  'share.title': '학습 기록 공유',
  'share.name': '표시 이름',
  'share.create': '공유 링크 만들기',
  'share.copied': '링크를 복사했어요!',
  'share.open': '공유 페이지 열기',
  'share.saveImage': '인증 이미지 저장',
  'share.myLinks': '내 공유 링크',
  'share.revoke': '삭제',
  'share.empty': '아직 공유 링크가 없어요 — 복습을 마치고 스트릭을 공유해 보세요.',
  'review.tapOrSpace': '카드를 탭하거나 스페이스를 눌러 뒤집기',
  'review.images': '이미지',
  'review.prefillMore': '{{topic}} 관련 단어와 표현 더보기',
  'review.endSession': '세션 종료',
  'review.error.loadFailed': '카드 로드에 실패했습니다',
  'review.error.submitFailed': '복습 결과 제출에 실패했습니다',

  // Stats view
  'stats.today': '오늘',
  'stats.reviewedToday': '오늘 복습',
  'stats.review_one': '복습',
  'stats.review_other': '복습',
  'stats.mastered': '마스터 완료',
  'stats.learned': '외운 단어',
  'stats.word_one': '단어',
  'stats.word_other': '단어',
  'stats.error': '통계를 불러오지 못했습니다',
  'stats.dailyGoal': '하루 목표',
  'stats.goalFresh': '새로운 시작.',
  'stats.goalGoing': '계속 가봐요.',
  'stats.goalMet': '목표 달성, 잘했어요.',
  'stats.goalHint': '탭해 속도 설정',

  // Settings view
  'settings.title': '설정',
  'settings.languagePair': '언어 쌍',
  'settings.learn': '학습',
  'settings.pairOption': '{{native}} → {{target}} 학습',
  'settings.pairGroup': '{{langA}} ↔ {{langB}}',
  'settings.cardsPerSession': '세션당 카드 수',
  'settings.cardLabel': '카드 {{count}}장',
  'settings.changeWarning': '언어를 변경하면 앱이 다시 로드됩니다',
  'settings.apply': '적용',
  'settings.cancelChange': '취소',

  // Settings — learning context (free-text goal that tunes AI generation)
  'settings.learningContext.label': '학습 목표',
  'settings.learningContext.optional': '선택',
  'settings.learningContext.placeholder': '예: GRE 어휘, HSK 대비, 비즈니스 영어…',
  'settings.learningContext.hint': 'AI 단어 선택에 영향을 줍니다. 비우면 기본값.',
  'settings.learningContext.try': '추천:',
  'settings.learningContext.example1': 'HSK 대비',
  'settings.learningContext.example2': '비즈니스 영어',
  'settings.learningContext.example3': '일상 회화',
  'settings.learningContext.example4': '호주 영어',

  // Settings — subscription
  'settings.plan.balanceTitle': '에너지 잔액',
  'settings.plan.balanceDesc': '{{balance}} 에너지 사용 가능',
  'settings.plan.topup': '${{amount}} 충전',
  'settings.plan.energyUnit': '{{energy}} 에너지',
  'settings.plan.bonusPct': '+{{percent}}% 보너스',
  'settings.plan.bestValue': '최고 혜택',
  'settings.support.title': '도움이 필요하신가요?',
  'settings.support.desc': '질문, 결제, 피드백 — 언제든 이메일 주세요.',
  'settings.referral.title': '친구 초대하고, 서로 150 에너지 받기',
  'settings.referral.desc': '링크를 공유하세요. 친구가 충전하면, 서로 150 에너지를 무료로 드립니다.',
  'settings.referral.yourCode': '내 초대 코드',
  'settings.referral.copyCode': '초대 코드 복사',
  'settings.referral.tapToCopy': '탭하여 복사',
  'settings.referral.codeCopied': '복사됨',
  'settings.referral.shareLink': '링크 공유',
  'settings.referral.invited_one': '{{count}}명 초대함',
  'settings.referral.invited_other': '{{count}}명 초대함',
  'settings.referral.toppedUp_one': '{{count}}명 충전',
  'settings.referral.toppedUp_other': '{{count}}명 충전',
  'settings.referral.pendingHint': '상대 첫 충전 대기 중 — 찔러보세요!',
  'settings.referral.shareText': '일상 사진으로 단어를 배워요. 충전하면 우리 모두 150 에너지 — Piccard 같이 해요:',
  'settings.referral.rewardBanner': '친구가 충전했어요 — 잔액에 150 에너지를 추가했습니다.',
  'settings.referral.rewardDismiss': '확인',
  'settings.referral.haveCode': '초대 코드 있어요?',
  'settings.referral.codePlaceholder': '코드 입력',
  'settings.referral.codeApply': '적용',
  'settings.referral.codeApplying': '적용 중…',
  'settings.referral.codeApplied': '코드 적용 완료 — 충전하면 회원님과 초대자가 각각 150 에너지를 받습니다.',
  'settings.referral.codeAlready': '이미 초대가 적용된 계정입니다.',
  'settings.referral.codeInvalid': '유효하지 않은 코드입니다.',
  'settings.referral.codeSelf': '본인의 코드입니다.',

  // Payment (shared)
  'payment.checkoutFailed': '결제를 시작할 수 없어요. 다시 시도해 주세요.',
  'payment.checkoutLoading': '결제 창을 여는 중…',
  'payment.checkoutSuccess': '충전 완료 — 감사합니다!',
  'payment.checkoutCancelled': '결제가 취소되었습니다.',

  // Hamburger menu
  'menu.notSignedIn': '로그인되지 않음',
  'menu.signOut': '로그아웃',
  'menu.languageLearner': '언어 학습자',

  // Onboarding
  'onboarding.iSpeak': '내가 구사하는 언어…',
  'onboarding.imLearning': '배우고 싶은 언어…',
  'onboarding.startLearning': '학습 시작',
  'onboarding.changeAnytime': '언제든지 변경할 수 있습니다',
  'onboarding.back': '← 돌아가기',
  'onboarding.learningContext.label': '특별한 목표가 있나요?',
  'onboarding.learningContext.placeholder': '예: GRE, HSK, 비즈니스 영어… (선택)',

  // Auth
  'auth.signInPrompt': '로그인하여 어휘를 클라우드에 저장하세요',
  'auth.continueWithGoogle': 'Google로 계속하기',
  'auth.continueWithKakao': '카카오 로그인',
  'auth.signingIn': '로그인 중...',
  'auth.signingYouIn': '로그인 처리 중...',
  'auth.signInFailed': '로그인 실패',
  'auth.signInError': '인증 중 문제가 발생했습니다',
  'auth.tryAgain': '다시 시도',
  'auth.loading': '로드 중...',

  // Error boundary
  'error.title': '문제가 발생했습니다',
  'error.description': '예기치 않은 오류가 발생했습니다',
  'error.tryAgain': '다시 시도',
  'error.report': '보고',

  // Offline
  'offline.title': '오프라인 상태입니다',
  'offline.description': '일부 기능이 제한될 수 있습니다. 연결 상태를 확인하세요',
  'offline.notification': '오프라인 알림',
  'offline.retryConnection': '다시 연결',

  // PWA install
  'pwa.installPrompt': 'Piccard를 설치하여 오프라인으로 사용하세요',
  'pwa.install': '설치',
  'pwa.dismiss': '닫기',
  'pwa.installAppPrompt': '앱 설치 안내',
  'pwa.installApp': '앱 설치',

  // Card stack
  'cardStack.cardGenerated': '카드 1장 생성됨',
  'cardStack.cardGenerated_other': '카드 {{count}}장 생성됨',
  'cardStack.counter': '{{current}} / {{total}} 카드',
  'cardStack.done': '완료',
  'cardStack.reviewNow': '지금 복습',
  'cardStack.generateMore': '더 만들기',
  'cardStack.allReviewed': '모든 카드를 확인했습니다',
  'cardStack.cardsSaved': '{{count}}장의 카드가 저장되었습니다',
  'cardStack.previousCard': '이전 카드',
  'cardStack.nextCard': '다음 카드',
  'cardStack.goToCard': '카드 {{n}}(으)로 이동',

  // Preview card
  'previewCard.generatedCard': '생성된 카드',
  'previewCard.translation': '번역',
  'previewCard.definition': '뜻',
  'previewCard.example': '예문',
  'previewCard.searchImagesFor': '{{word}} 이미지 검색',

  // Rating buttons
  'rating.again': '다시',
  'rating.hard': '어려움',
  'rating.good': '좋음',
  'rating.easy': '쉬움',
  'rating.master': '마스터',
  'rating.rateAs': '{{label}}(으)로 평가',
  'rating.markMastered': '마스터로 표시',
  'review.stuckHint': "이 카드는 {{count}}번 놓쳤어요 — 당신 탓이 아닙니다, 안 붙는 카드도 있어요. 아래에서 은퇴하거나 계속하세요.",

  // Study card
  'studyCard.studyCardFor': '{{word}} 학습 카드',
  'studyCard.playUsPronunciation': '미국식 발음 듣기',
  'studyCard.playUkPronunciation': '영국식 발음 듣기',
  'studyCard.searchImagesFor': '{{word}} 이미지 검색',

  // Pronunciation button + badge
  'pronunciation.play': '{{accent}} 발음 듣기',

  // Search bar
  'search.clearSearch': '검색 지우기',

  // Tag cloud
  'tagCloud.yourTopics': '나의 주제',
  'tagCloud.showMore': '{{label}} {{count}}개 더 보기',

  // Queue item
  'queueItem.remove': '{{word}} 제거',

  // Error card
  'errorCard.defaultRetry': '다시 시도',

  // Empty state
  'emptyState.noCards': '아직 카드가 없습니다',
  'emptyState.noCardsHint': '첫 번째 플래시카드를 만들어 시작하세요',
  'emptyState.createCard': '카드 만들기',
  'emptyState.noMastered': '아직 마스터한 단어가 없습니다',
  'emptyState.noMasteredHint': '카드를 마스터로 표시하면 여기에 나타납니다',
  'emptyState.allMastered': '모든 카드를 마스터했습니다!',
  'emptyState.greatJob': '훌륭합니다!',

  // Progress bar
  'progressBar.cardsLearned': '학습한 카드',

  // AI image regeneration (shared RegenerateImageButton)
  'common.aiImage': 'AI 이미지',
  'common.aiImagePremium': 'Premium',
  'common.aiImageAria': '{{word}}의 AI 이미지 생성',
  'common.generating': '생성 중…',
  'common.imageFailed': '실패 · 에너지 미사용',
  'common.lowEnergy': '에너지 부족',
  'common.regenerateCard': '재생성',
  'common.regenerateCardAria': '{{word}} 완전 재생성',

  // Image preview / lightbox
  'imagePreview.enlarge': '이미지 확대',
  'imagePreview.close': '닫기',

  // Document import view (PDF/TXT → candidate vocab)
  'importView.title': '문서 가져오기',
  'importView.subtitle': 'PDF나 텍스트를 단어 카드로 만드세요.',
  'importView.chooseFile': 'PDF 또는 텍스트 파일 선택',
  'importView.pasteLabel': '또는 텍스트 붙여넣기',
  'importView.pastePlaceholder': '글, 메모, 텍스트를 붙여넣으세요…',
  'importView.findVocab': '어휘 찾기',
  'importView.proposing': '어휘를 찾는 중…',
  'importView.proposingWait': '단어를 고르고 뜻을 쓰는 중 — 긴 텍스트는 10~20초 걸려요.',
  'importView.phaseReading': '텍스트를 읽는 중…',
  'importView.foundSoFar': '{{n}}개 찾았어요 · 계속 찾는 중…',
  'importView.cancel': '취소',
  'importView.partialBanner': '{{n}}개를 찾았지만 분석이 중간에 멈췄어요.',
  'importView.retryRest': '나머지 찾기',
  'importView.parsing': '문서를 읽는 중…',
  'importView.candidates': '후보 {{count}}개',
  'importView.keepN': '{{count}}개 유지 · 에너지 {{energy}}',
  'importView.generate': '{{count}}장의 카드 만들기',
  'importView.selectAll': '모두 선택',
  'importView.clearAll': '모두 해제',
  'importView.priorityHigh': '고가치',
  'importView.highCount': '고가치 {{high}} / 총 {{total}}',
  'mediaView.selectRecommended': '추천 선택',
  'importView.success': '{{count}}장의 카드가 추가되었습니다',
  'importView.pairMismatch': '카드는 {{pair}}(으)로 저장됩니다 — 현재 앱 설정은 {{current}}입니다. 복습 전에 설정에서 전환하세요.',
  'importView.savedAs': '{{pair}}(으)로 저장됨',
  'importView.reviewInPair': '{{pair}}(으)로 전환 후 복습',
  'importView.reviewNow': '지금 복습',
  'importView.errorTooLarge': '문서가 너무 큽니다 (최대 약 80만 자).',
  'importView.errorScanned': '선택할 텍스트가 없습니다 — 스캔 PDF로 보입니다.',
  'importView.errorRead': '이 파일을 읽을 수 없습니다.',
  'importView.errorPropose': '어휘를 추출할 수 없습니다. 다시 시도해 주세요.',
  'importView.errorRateLimited': '요청이 잠시 몰렸어요. 1분 뒤에 다시 시도해 주세요.',
  'importView.errorLowEnergy': '에너지가 부족하여 카드를 저장할 수 없습니다.',
  'importView.empty': '어휘를 찾지 못했습니다. 다른 문서를 시도해 보세요.',

  // Quick save view (extension lookup → one-step card)
  'quickSave.title': 'Piccard에 저장',
  'quickSave.subtitle': '한 번 누르면 바로 복습할 수 있는 카드가 완성됩니다.',
  'quickSave.generate': '카드 만들기',
  'quickSave.generateCost': '카드 만들기 · {{energy}} 에너지',
  'quickSave.generating': '카드 만드는 중…',
  'quickSave.slowWait': '카드 만들기는 보통 몇 초 걸려요 — 잠시만 기다려 주세요.',
  'quickSave.pairSourceExtension': '이 영상에서',
  'quickSave.pairSourceSettings': '앱 설정',
  'quickSave.pairSourceBrowser': '브라우저 언어',
  'quickSave.fromYoutube': '이 영상에서',
  'quickSave.fromNetflix': '이 작품에서',
  'quickSave.pairLabel': '카드 언어',
  'quickSave.energyHint': '생성에 {{energy}} 에너지 · 잔액 {{balance}}',
  'quickSave.errorBalance': '에너지가 부족하여 카드를 만들 수 없어요.',
  'quickSave.errorNetwork': '카드를 만들지 못했어요. 다시 시도해 주세요.',
  'quickSave.topUp': '충전',
  'card.fromSource': '문서에서',
  'card.grammar': '문법',
  'card.prosody': '강세와 리듬',
  'card.fromClip': '클립',
  'card.fromYoutube': 'YouTube',
  'card.openInNetflix': '넷플릭스에서 열기',
  'card.fromNetflix': '넷플릭스',
  'card.fromPdf': 'PDF',
  'card.fromPhoto': '내 사진',
  'card.lookedUp': '단어 조회',
  'card.expand': '펼치기',
  'card.collapse': '접기',

  'mediaView.title': '영상을 카드로 만들기',
  'mediaView.subtitle': '영어 음성이나 영상을 올리세요. 전사하고, 당신이 고릅니다.',
  'mediaView.chooseFile': '파일을 드롭하거나 탭하여 선택',
  'mediaView.formats': 'mp4 · mov · webm · mp3…',
  'mediaView.cap': '최대 90분 · 최대 100MB',
  'mediaView.guideExtension.body': '확장 프로그램을 설치하셨나요? YouTube/Netflix 영상 페이지에서 자막의 단어를 선택하고 Piccard 버튼을 누르면 카드로 저장돼요. 아래에서 직접 영상/오디오 파일을 가져올 수도 있어요 →',
  'mediaView.guideExtension.dismiss': '닫기',
  'mediaView.uploading': '업로드 중…',
  'mediaView.transcribe': '전사',
  'mediaView.transcribing': '전사 중…',
  'mediaView.transcribeHint': '짧은 영상은 몇 초면 됩니다.',
  'mediaView.changeFile': '파일 변경',
  'mediaView.costN': '{{energy}} 에너지',
  'mediaView.phrases': '{{count}}개 구절',
  'mediaView.make': '{{count}}장 카드 만들기',
  'mediaView.uncertain': '이 구문 확인',
  'mediaView.preview': '이 구문 재생',
  'mediaView.success': '{{count}}장 카드가 복습 준비됐습니다',
  'mediaView.errorUpload': '업로드 실패. 다시 시도하세요.',
  'mediaView.errorTooLarge': '100MB 초과 — 더 짧게 자르세요.',
  'mediaView.errorSilent': '음성이 감지되지 않았습니다. 무음 영상일 수 있어요 — 대사가 있는 영상을 선택하세요.',
  'mediaView.errorFormat': '지원하지 않는 형식. mp4·mov·webm 또는 오디오 파일을 사용하세요.',
  'mediaView.errorTranscribe': '전사 서비스가 바쁩니다. 다시 시도하세요 — 과금되지 않습니다.',
  'mediaView.tooLongDuration': '{{n}}분 초과 — 클립을 더 짧게 자른 뒤 다시 추가하세요.',
  'mediaView.errorContent': '이 파일에서 영어 음성이 감지되지 않았습니다.',
  'mediaView.errLanguageMismatch': '이 클립은 {{lang}}이(가) 아닌 것 같아요. {{lang}} 미디어를 선택하거나 먼저 학습 언어를 변경하세요.',
  'mediaView.errBadFormat': '이 파일의 실제 형식은 전사할 수 없습니다(.avi/.mkv를 .mp4로 바꾼 경우 등). mp4, mov, webm 또는 일반 오디오 형식으로 변환해 주세요.',
  'mediaView.errNoSpeech': '이 파일에서 음성이 감지되지 않았습니다. 대화가 선명한 클립을 선택하세요.',
  'mediaView.errDecode': '이 파일의 오디오를 처리할 수 없습니다. 표준 mp4·mov·webm 또는 오디오 파일을 사용해 보세요.',
  'mediaView.fromFile': '{{name}}에서',
  'mediaView.errorLowEnergy': '에너지가 부족합니다.',
  'mediaView.errorConfirm': '이 구문들로 카드를 만들 수 없습니다. 다시 시도하세요.',
  'mediaView.empty': '이 영상에 구절이 없습니다.',
  'mediaView.costEstimate': '약 {{cost}} 에너지 · 약 {{min}}분',
  'mediaView.feeApplied': '({{n}} 에너지 감지 수수료 부과됨)',
  'settings.section.energy': '에너지',
  'settings.section.learning': '학습',
  'redeem.title': '코드 교환',
  'redeem.desc': '코드를 입력하여 에너지를 받으세요.',
  'redeem.placeholder': '코드 입력',
  'redeem.apply': '교환',
  'redeem.applying': '…',
  'redeem.success': '교환 완료! +{{cents}} 에너지',
  'redeem.already': '이미 이 코드를 교환하셨습니다.',
  'redeem.invalid': '유효하지 않거나 만료된 코드',
  'redeem.error': '문제가 발생했습니다. 다시 시도해 주세요.',
  'redeem.balance': '{{balance}} 에너지 사용 가능',

  // Landing (v11 — extension-first entry, closed loop. Copy frozen in
  // docs/plans/landing-v11.md; ko keywords in docs/plans/seo-research/ko-keywords.md)
  'landing.hero.title': '유튜브로 영어 공부\n보던 영상이 단어장이 됩니다',
  'landing.hero.subtitle': '보던 영상에 이중 자막을 띄우세요. 문장 한 줄을 탭하고 클릭 한 번으로 카드를 만드세요 — 뜻, 예문, 발음이 담긴 카드가 하나씩 잊기 직전에 다시 돌아옵니다.',
  'landing.hero.cta': '무료로 시작',
  'landing.hero.ctaNote': '무료입니다. 카드 등록도 필요 없어요.',
  'landing.hero.ctaExtension': 'Chrome에 추가',
  'landing.hero.videoCaption': '이중 자막 패널에서 Piccard로 — 문장 한 줄이 여러 후보 카드가 됩니다.',
  'landing.how.title': '유튜브 영어 단어 정리, 세 단계',
  'landing.how.subtitle': '보는 것이 그대로 복습이 됩니다 — 순환은 저절로 이어져요.',
  'landing.how.step1Title': '이중 자막으로 영상 보기',
  'landing.how.step1Desc': '크롬 확장 프로그램이 보고 있는 영상에 한국어 자막을 얹어 줍니다. 모든 문장이 초 단위로 맞아떨어져요.',
  'landing.how.step2Title': '문장을 탭하고, 카드를 남기세요',
  'landing.how.step2Desc': '탭 한 번으로 문장이 Piccard로 갑니다. 클릭 한 번으로 카드를 만들면 뜻, 예문, 발음까지 담긴 카드가 완성됩니다. 마음에 드는 카드만 남기고 나머지는 버리세요.',
  'landing.how.step3Title': '복습은 알아서 돌아옵니다',
  'landing.how.step3Desc': 'FSRS 간격 반복이 모든 카드를 잊기 직전에 돌아오도록 일정을 잡습니다 — 각 카드는 출처가 된 유튜브 장면을 그대로 다시 재생해요.',
  'landing.how.otherTitle': '다른 시작 방법',
  'landing.how.other3': '웹에서 단어를 더블클릭하면 오프라인 사전 뜻이 뜨고, 한 번 더 클릭하면 Piccard가 카드를 만들어 줍니다.',
  'landing.how.ownLink': '갖고 있는 단어장 가져오기 →',

  // landing-v12 P1-2: persona-2 section (OwnMaterial.tsx) — bring your own list
  'landing.bring.title': '갖고 있던 목록이 곧 카드가 됩니다',
  'landing.bring.subtitle': '영상은 한 가지 시작점일 뿐입니다. 정말 필요한 단어 대부분은 이미 어딘가에 있습니다 — 교재 한 챕터, 시험 단어장, 강의 녹음. 붙여넣거나 올리면 Piccard가 카드를 제안하고, 그중 배울 가치가 있는 것만 남기면 됩니다.',
  'landing.bring.pasteTitle': '텍스트 붙여넣기',
  'landing.bring.pasteDesc': '교재 한 페이지, 기사, 이미 손에 있는 단어장. 붙여넣으면 제안 카드가 돌아옵니다 — 전체 선택도 가능하고, 걸러 남기기도 가능합니다. 한 번의 확인으로 최대 20장.',
  'landing.bring.pdfTitle': 'PDF 올리기',
  'landing.bring.pdfDesc': '강의 자료, 시험 단어장, 리딩 프린트 — PDF도 같은 제안 흐름을 통과합니다. 카드가 놓이면 고르고, 한 번 확인으로 끝납니다.',
  'landing.bring.fileTitle': '음성·영상 업로드',
  'landing.bring.fileDesc': '영어 강의나 팟캐스트 녹음(최대 90분)은 전사된 뒤 구문마다 배울 가치 점수 0–100(학습 목표 반영)이 붙고, 남길 것들은 미리 체크되어 돌아옵니다. 올릴 수 있는 것은 학습 중인 언어의 오디오입니다(영어 학습은 영어 강의).',
  'landing.bring.cta': '앱 열기',
  'landing.bring.ctaNote': '무료로 시작. 신용카드가 필요 없어요.',
  'landing.pricing.title': '쓴 만큼만 내는 구조',
  'landing.pricing.subtitle': '가입 에너지로 시작하고, 더 쓰고 싶을 때 충전하세요. 에너지는 없어지지 않습니다.',
  'landing.pricing.starter': '스타터',
  'landing.pricing.starterPrice': '₩0',
  'landing.pricing.starterToBegin': '로 시작',
  'landing.pricing.starterGrant': '가입 시 에너지 150 무료',
  'landing.pricing.starterSwitch': '언제든 언어 변경',
  'landing.pricing.starterSrs': '간격 반복 학습 완전 제공',
  'landing.pricing.starterDevices': '어떤 기기에서든',
  'landing.pricing.starterSync': '클라우드 동기화 포함',
  'landing.pricing.starterCta': '시작하기',
  'landing.pricing.topup': '충전 패키지',
  'landing.pricing.topupRate': '에너지 1 = 텍스트 카드 1장',
  'landing.pricing.starterAiImage': '텍스트 카드 포함, AI 이미지 카드는 유료 기능입니다',
  'landing.pricing.topupCards': '$5에 카드 500장',
  'landing.blog.backHome': '← 홈으로',
  'landing.welcome.openApp': 'Piccard 열기',
  'landing.faq.heading': '자주 묻는 질문',
  'landing.faq.q1': '정말 무료인가요?',
  'landing.faq.a1': '네! 새 계정마다 에너지 150을 무료로 드립니다 — 영상 몇 편, PDF 몇 개, 카드 약 150장 분량입니다. 더 필요할 때만 충전 패키지($5/$10/$20)로 충전하세요. 에너지는 절대 만료되지 않습니다.',
  'landing.faq.q2': 'Language Reactor나 Anki와 뭐가 다른가요?',
  'landing.faq.a2': '둘 다 좋은 도구지만 사이에 간극이 있습니다. Language Reactor는 자막을 보여주지만 단어를 저장하려면 Anki로 내보내고 다시 가져와야 하고, Anki 자체도 제대로 쓰려면 세팅이 필요합니다 — 카드를 하나하나 직접 만들어야 하죠. Piccard는 이 간극을 메웁니다. 자막 한 줄을 탭하면 뜻, 예문, 발음까지 담긴 완성된 카드가 돌아오고, 남길 것만 남기고 나머지는 버리면 됩니다. 복습 일정은 Anki도 채택한 최신 알고리즘, FSRS-6가 잡아줍니다. 긴 영상을 가져오면 표현마다 학습 가치 점수(0–100)와 한 줄 이유가 붙고 학습 목표도 반영되어, 어떤 단어에 시간을 쓸지 고민할 필요가 없습니다. 설정도 없고, 내보내기/가져오기 다리도 없습니다.',
  'landing.faq.q3': '유튜브가 느려지거나 자막이 깨지진 않나요?',
  'landing.faq.a3': '아니요. 확장 프로그램은 가볍고, 영상 위에 자체 자막 패널을 얹는 방식이라 유튜브 자체는 수정하지 않습니다. 필요 없어지면 클릭 한 번으로 전부 지울 수 있습니다. 계정 없이도 동작합니다.',
  'landing.faq.q5': '간격 반복이 뭔가요?',
  'landing.faq.a5': '복습 일정을 잡아주는 알고리즘입니다 — 처음엔 생생할 때 자주, 장기 기억에 자리 잡을수록 점점 드물게 카드가 돌아옵니다. Piccard는 Anki도 채택한 최신 알고리즘 FSRS-6를 사용하고, 카드는 당신이 보고 읽는 것에서 저절로 만들어집니다.',
  'landing.faq.q7': '어떤 언어를 지원하나요?',
  'landing.faq.a7': '한국어 · 繁體中文 · 日本語 최우선 — Piccard는 영어를 배우는 한국어·번체중국어·일본어 사용자를 위해 만들어졌습니다. 스페인어, 프랑스어, 독일어도 이용할 수 있고, 언제든 전환할 수 있습니다.',

  'landing.faq.q8': '이미 갖고 있는 단어장이 있습니다. 카드로 만들 수 있나요?',
  'landing.faq.a8': '네 — 가장 빠른 시작법입니다. 텍스트를 붙여넣거나 PDF를 올리면 카드가 제안됩니다(한 번에 최대 20장). 뜻, 예문, 발음이 담깁니다. 강의 녹음도 됩니다 — 오디오를 올리면 전사되고 구문마다 배울 가치 점수(0–100)가 붙습니다.',
  'landing.faq.q9': '넷플릭스에서도 쓸 수 있나요?',
  'landing.faq.a9': '네, 텍스트 자막이 있는 작품이면 됩니다. 작품이 두 언어 자막을 모두 제공하면 영상 위에 이중 자막(영어+내 언어)도 표시돼요. 패널을 켜고 보다가 문장을 탭하면 카드가 만들어지고, 카드에서 그 장면의 정확한 초로 넷플릭스를 다시 열 수 있어요. 일부 작품은 그림 자막이라 읽지 못하고, DRM 때문에 스크린샷·음성 담기는 안 됩니다 — 단어와 그 순간이 남아요.',
  'landing.faq.still': '더 궁금한 점이 있나요? 이메일:',
  'landing.footer.tagline': '보는 것에서 만드는 단어카드',
  'landing.footer.blog': '블로그',
  'landing.footer.privacy': '개인정보 처리방침',
  'landing.footer.terms': '이용약관',
  'landing.footer.contact': '문의',
  'landing.footer.rights': 'All rights reserved.',
  'landing.finalCta.title': '첫 플래시카드는 유튜브 영상 하나면 됩니다',
  'landing.finalCta.subtitle': '영상을 보고, 문장을 탭하고, 카드를 만드세요 — 잊기 전에 다시 돌아옵니다.',
  'landing.finalCta.cta': '무료로 시작하기',
  'landing.finalCta.ctaExtension': 'Chrome에 추가',
  'landing.finalCta.note': '카드 등록 불필요. 에너지 150 포함.',

  // SEO — prerendered HTML shells (docs/plans/multilingual-seo.md M1)
  'seo.title': '유튜브 영어 단어장 — 이중 자막과 단어카드 | Piccard',
  'seo.description': '유튜브 이중 자막으로 영어 단어장을 만들세요. 문장 한 줄을 탭하면 완성된 단어카드가 돌아오고, 남긴 카드는 FSRS 간격 반복으로 잊기 전에 다시 만나게 됩니다.',
}
